export default __webpack_public_path__ + "static/media/tour2.a6ff6436.PNG";